import React from "react";
import {IntlProvider} from "react-intl";
import {getCurrentTranslation} from "../utils/translations";
import PropTypes from "prop-types";
import OrderCard from "./Order/form";

const Order = ({config}) => {

    return (
        <IntlProvider messages={getCurrentTranslation(config.locale)} locale={config.locale} defaultLocale="cs">
            <OrderCard config={config} />
        </IntlProvider>
    );

}

Order.propTypes = {
    config: PropTypes.object.isRequired
};

Order.defaultProps = {}

export default Order;
